App.controller('FormCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'insuranceService', 'statesService', '$filter', 'profileService', 'dataUser', '$q', 'popUpService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, insuranceService, statesService, $filter, profileService, dataUser, $q, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'insurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja (dane i oświadczenia)';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.insurance.package';
    $scope.$emit('link', $scope.link);

    $scope.data = {};

    $scope.package = $scope.stateParams.package;
    $scope.data.benefit = $scope.package;

    if ($scope.data.benefit) {
        delete $scope.data.benefit.creationTime;
        delete $scope.data.benefit.benefitGroup.creationTime;
    }

    $scope.userData = JSON.parse(window.sessionStorage.getItem('userObject'));

    $scope.data.person = $scope.userData.person;
    delete $scope.data.person.creationTime;

    console.log($scope.userData);

    if ($scope.userData.person.address) {
        $scope.data.person.address = $scope.userData.person.address;
        delete $scope.data.person.address.creationTime;
        $scope.selectedItemLocalization = $scope.userData.person.address.city;
    }

    $scope.acceptStatement = [];
    for (var a = 0; a < 1; a++) {
        $scope.acceptStatement[a] = false;
    }

    if ($scope.stateParams.branch) {
        $scope.data.branch = $scope.stateParams.branch.name;
    }

    $scope.data.partner = {};
    $scope.data.children = [];

    // $scope.$watchGroup(['children.identifier', 'children.birthdate'], function () {
    //     if ($scope.data.children.citizenshipType === 'POLISH') {
    //         if ($filter('isOver16FromIdentifier')($scope.data.children.identifier)) {
    //             // dodaj pole z mailem
    //         } else {
    //             // ukryj pole z mailem
    //         }
    //     } else {
    //         if ($filter('isOver16FromBirthdate')($scope.data.children.birthdate)) {
    //             // dodaj pole z mailem
    //         } else {
    //             // ukryj pole z mailem
    //         }
    //     }
    // });

    $scope.accept = function() {
        console.log($scope.form);
        $scope.form.$setSubmitted();
        $scope.register($scope.form);
    }

    $scope.register = function(form) {
        console.log(form);

        if (!form.$valid) {
            return 0;
        }

        if (!$scope.acceptStatement[0]) {
            $scope.showPopUp('', 'Zaakceptuj oświadczenia', 'Aby zatwierdzić deklarację zaakceptuj wymagane oświadczenia.');
            return 0;
        }

        var childrenLength = Object.keys($scope.data.children).length;
        var partnerLength = ($scope.data.partner && Object.keys($scope.data.partner).length) ? 1 : 0;

        if ($scope.package.partner && !$scope.package.children) {
            if (childrenLength + partnerLength < 1) {
                $scope.showPopUp('', 'Dodaj partnera', 'Aby zatwierdzić deklarację musisz dodać partnera lub dziecko.');
                return 0;
            }
        } else if ($scope.package.partner && $scope.package.children) {
            if (childrenLength + partnerLength < 2) {
                $scope.showPopUp('', 'Dodaj osoby', 'Aby zatwierdzić deklarację musisz dodać co najmniej 2 osoby.');
                return 0;
            }
        }

        var len = Object.keys($scope.data.children).length;
        if (len) {
            for (var a = 0; a < len; a++) {
                if ($scope.data.children[a].member === 'CHILD') {
                    if ($scope.data.children[a].nationality === 'POLISH') {
                        if ($filter('isOver26FromIdentifier')($scope.data.children[a].identifier)) {
                            $scope.showPopUp('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 26 lat.', '');
                            return 0;
                        }
                    } else {
                        if ($filter('isOver26FromBirthdate')($scope.data.children[a].birthdate)) {
                            $scope.showPopUp('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 26 lat.', '');
                            return 0;
                        }
                    }
                }
            }
        }

        if (Object.keys($scope.data.partner).length) {
            $scope.data.partner.identifierType = ($scope.data.partner.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
            $scope.data.partner.identifier = ($scope.data.partner.nationality !== 'POLISH') ? $scope.data.partner.id : $scope.data.partner.identifier;
            $scope.data.partner.birthdate = ($scope.data.partner.nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($scope.data.partner.birthdate) : $filter('getDateFromIdentifier')($scope.data.partner.identifier);
            $scope.data.partner.citizenshipType = $scope.data.partner.nationality;
            $scope.data.partner.address.city = $scope.data.partner.selectedItemLocalization;

            delete $scope.data.partner.selectedItemLocalization;
            delete $scope.data.partner.nationality;
            delete $scope.data.partner.id;
            delete $scope.data.partner.sameAddress;
        } else {
            delete $scope.data.partner;
        }

        var len = Object.keys($scope.data.children).length;
        if (len) {
            for (var a = 0; a < len; a++) {

                // if ($scope.children[a].citizenshipType === 'POLISH') {
                //     if ($filter('isAdultFromIdentifier')($scope.children[a].identifier)) {
                //         $scope.data.children[a].type = 'ADULT_CHILD';
                //     }
                // } else {
                //     if ($filter('isAdultFromBirthdate')($scope.children[a].birthdate)) {
                //         $scope.data.children[a].type = 'ADULT_CHILD';
                //     }
                // }

                $scope.data.children[a].identifierType = ($scope.data.children[a].nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
                $scope.data.children[a].identifier = ($scope.data.children[a].nationality !== 'POLISH') ? $scope.data.children[a].id : $scope.data.children[a].identifier;
                $scope.data.children[a].birthdate = ($scope.data.children[a].nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($scope.data.children[a].birthdate) : $filter('getDateFromIdentifier')($scope.data.children[a].identifier);
                $scope.data.children[a].citizenshipType = $scope.data.children[a].nationality;
                $scope.data.children[a].address.city = $scope.data.children[a].selectedItemLocalization;

                delete $scope.data.children[a].selectedItemLocalization;
                delete $scope.data.children[a].nationality;
                delete $scope.data.children[a].id;
                delete $scope.data.children[a].sameAddress;
            }
        }

        $scope.data.person.citizenshipType = $scope.data.person.nationality;
        $scope.data.person.address.city = $scope.selectedItemLocalization;
        $scope.data.proposedDate = $scope.stateParams.proposedDate;
        $scope.data.branch = $scope.userData.branch.name;

        console.log($scope.data);

        insuranceService.add($scope.data).then(function (data) {
            if (data.status === 200) {
                dataUser.update();
                $scope.showPopUp('', 'Gratulacje!', 'Twoja deklaracja została zgłoszona.', 'Przejdź do listy deklaracji', 'root.home.insurance.list', 'false');
            } else {
                popUpService.showPopUpWithError(data.data, {ev: '', head: 'Zgłoszenie nieudane', content: 'Niestety nie udało się zgłosić deklaracji, skontaktuj się z administratorem.', text: '', target: ''});
            }
        });
    }

    $scope.showInformationObligation = function() {
        $scope.showPopUpInformationObligation('');
    }

    $scope.showPopUp = function(ev, head, content, text, target, exit) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                exit: exit,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {

        }, function() {

        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }

    $scope.showPopUpInformationObligation = function(ev) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-obligation-declaration.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {

            }
        }).then(function(data) {

        }, function() {

        });
    }

    $scope.add = function(type) {
        if (type === 'PARTNER') {
            $scope.data.partner = {
                birthdate: new Date('01/01/2000'),
                selectedItemLocalization: null,
                nationality: 'POLISH',
                address: $scope.data.person.address,
                selectedItemLocalization: $scope.selectedItemLocalization,
                sameAddress: true
            };

            $scope.partner_length = 1;
            $scope.partner_block = true;

            if (!$scope.package.children) {
                $scope.children_block = true;
            }
        }

        if (type === 'CHILD') {

            $scope.data.children.push({
                birthdate: new Date('01/01/2000'),
                selectedItemLocalization: null,
                nationality: 'POLISH',
                member: 'CHILD',
                address: $scope.data.person.address,
                selectedItemLocalization: $scope.selectedItemLocalization,
                sameAddress: true
            });

            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = true;
                $scope.children_block = true;
            } else {
                if ($scope.children_length >= $scope.package.children) {
                    $scope.children_block = true;
                }
            }
        }
    }

    var getResults = function(query) {
        var deferred = $q.defer();

        statesService.dataCityLists({
            name: query
        }).then(function(data) {
            deferred.resolve(data.data);
        });

        return deferred.promise;
    };

    // ##### LOCALIZATION FILTER ##### //
    $scope.querySearchLocalization = function(query) {
        if (!query) {
            return;
        }

        return getResults(query).then(function(results) {
            return results;
        });
    };

    $scope.selectedItemLocalization  = null;
    $scope.searchTextLocalization    = null;

    $scope.selectedItemMainLocalization  = null;
    $scope.searchTextMainLocalization    = null;

    $scope.delete = function(obj) {
        if (obj === 'partner') {
            $scope.data.partner = {};
            $scope.partner_length = 0;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.partner_block = false;
            }
        } else {
            $scope.data.children.splice(obj, 1);
            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.children_block = false;
            }
        }
    }

    if (!$scope.package) {
        $state.go('root.home.insurance.package');
    }

    $scope.$watch('data.person.address', function(oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = $scope.data.person.address;
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = $scope.data.person.address;
                    }
                }
            }
        }
    }, true);

    $scope.$watch('selectedItemLocalization', function(oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.selectedItemLocalization = $scope.selectedItemLocalization;
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].selectedItemLocalization = $scope.selectedItemLocalization;
                    }
                }
            }
        }
    }, true);

    var collection = ['data.partner.sameAddress', 'data.children[0].sameAddress', 'data.children[1].sameAddress', 'data.children[2].sameAddress', 'data.children[3].sameAddress', 'data.children[4].sameAddress', 'data.children[5].sameAddress'];
    $scope.$watchGroup(collection, function(oldVal, newVal) {
        console.log('change');
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = $scope.data.person.address;
                    $scope.data.partner.selectedItemLocalization = $scope.selectedItemLocalization;
                } else {
                    $scope.data.partner.address = {};
                    $scope.data.partner.selectedItemLocalization = null;
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = $scope.data.person.address;
                        $scope.data.children[a].selectedItemLocalization = $scope.selectedItemLocalization;
                    } else {
                        $scope.data.children[a].address = {};
                        $scope.data.children[a].selectedItemLocalization = null;
                    }
                }
            }
        }
    });
}]);
